import { supabase } from './supabase'

// Escolha de cookies do visitante (23/10/2026). Cookies essenciais funcionam
// sempre; a medição (Google Analytics e PostHog) só com "Aceitar". A escolha
// fica neste navegador e também na BD (consentimentos_cookies, com a versão da
// Política de Cookies em vigor), com um identificador aleatório — não pessoal.
//
// O aviso antigo (chave 'cookieConsent') só tinha "Aceitar" e não ligava nada
// à escolha, por isso não conta: quem o aceitou volta a ver o aviso novo.

const CHAVE = 'tamoaki_cookies'
const CHAVE_VISITANTE = 'tamoaki_visitante'
export const EVENTO_ESCOLHA = 'tamoaki:cookies'
export const EVENTO_ABRIR = 'tamoaki:cookies-abrir'

export type EscolhaCookies = { medicao: boolean; data: string }

function guardado(chave: string): string | null {
  try {
    return localStorage.getItem(chave)
  } catch {
    return null
  }
}

export function lerEscolha(): EscolhaCookies | null {
  const bruto = guardado(CHAVE)
  if (!bruto) return null
  try {
    const e = JSON.parse(bruto)
    return typeof e?.medicao === 'boolean' && typeof e?.data === 'string' ? e : null
  } catch {
    return null
  }
}

export function temConsentimentoMedicao(): boolean {
  return lerEscolha()?.medicao === true
}

function visitante(): string {
  let id = guardado(CHAVE_VISITANTE)
  if (!id || !/^[0-9a-f-]{36}$/i.test(id)) {
    id = crypto.randomUUID()
    try { localStorage.setItem(CHAVE_VISITANTE, id) } catch { /* sem armazenamento: regista na mesma */ }
  }
  return id
}

export function guardarEscolha(medicao: boolean): void {
  const escolha: EscolhaCookies = { medicao, data: new Date().toISOString() }
  try { localStorage.setItem(CHAVE, JSON.stringify(escolha)) } catch { /* vale só para esta visita */ }
  window.dispatchEvent(new CustomEvent<EscolhaCookies>(EVENTO_ESCOLHA, { detail: escolha }))
  supabase
    .rpc('registar_escolha_cookies', { p_visitante: visitante(), p_app: 'site', p_medicao: medicao, p_user_agent: navigator.userAgent })
    .then(({ error }) => { if (error) console.warn('[cookies] escolha não registada:', error.message) })
}

/** Volta a mostrar o aviso (ligação "Preferências de cookies"). */
export function abrirPreferenciasCookies(): void {
  window.dispatchEvent(new Event(EVENTO_ABRIR))
}
